import BasePDFDefinitionBuilder from '../../../pdf/BasePDFDefinitionBuilder'
import messageResource from '../../../messageResource'
import $ from 'jquery'
import _ from 'underscore'
import ViewTTStore from '../ViewTTStore'
import UserTime from '../../../user_time'
import {cutLongText, cutNumberOfTextLines} from '../../../util/StringUtils'

export default class PDFDefinitionBuilder extends BasePDFDefinitionBuilder {

    getAdditionalStyles() {
        return PDFDefinitionBuilderStyles;
    }

    getAdditionalParameters() {
        return PDFDefinitionBuilderParameters;
    }

    getAdditionalTableLayouts() {
        return {};
    }

    initDocDefinitionObject(withSignatureOnEachPage, headerOnEachPage) {
        super.initDocDefinitionObject(headerOnEachPage)
        var margins = [];
        _.extend(margins, this.dd.pageMargins);
        if (withSignatureOnEachPage)
        {
            margins[3] += 40; //TODO adjust with parameters
        }
        this.dd.pageMargins = margins;

        this.dd.pageBreakBefore = function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage)
        {
            if (currentNode.headlineLevel === 1)
            {
                for (var i = 0; i < followingNodesOnPage.length; i++)
                {
                    if (followingNodesOnPage[i].headlineLevel == 2)
                        return false;
                }

                return true;
            }
            return false;
        }
    }

    _createSignatureRows() {
        return [
            [
                {
                    style: 'footerSignatureSeparator',
                    canvas: [
                        {
                            type: 'line',
                            x1: 0, x2: 200,
                            y1: 0, y2: 0,
                            lineWidth: 0.4,
                            lineColor: '#3D3D3D'
                        }
                    ]
                },
                "",
                {
                    style: 'footerSignatureSeparator',
                    canvas: [
                        {
                            type: 'line',
                            x1: 0, x2: 200,
                            y1: 0, y2: 0,
                            lineWidth: 0.4,
                            lineColor: '#3D3D3D'
                        }
                    ]
                }
            ],
            [{text: messageResource.getMessage('view_tt.pdf.footer.signature'), style: "footerSignature"}, "", {text: messageResource.getMessage("view_tt.pdf.footer.date"), style: "footerSignature"}]
        ];
    }

    addSignatureToEnd() {
        this.appendContentElement(
                {
                    style: 'footerTable',
                    margin: [0, 20, 0, 0],
                    layout: 'noBordersNoPadding',

                    table: {
                        widths: ["40%", "20%", "40%"],
                        body: this._createSignatureRows()
                    }
                }
        );
    }

    addFooterWithSignature(withSignature) {
        var footerMargins = this.p("footerMargins")(this.p("pageMargins"));
        if (withSignature)
        {
            footerMargins = $.extend([], footerMargins);
            footerMargins[1] += 30;
        }
        var s = this;
        this.dd.footer = function()
        {
            return function(currentPage, pageCount)
            {
                var footerRows = [];
                if (withSignature)
                {
                    footerRows = footerRows.concat(s._createSignatureRows());
                }
                footerRows.push(["", "", {style: "footerPageCount", text: messageResource.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount])}]);
                return {
                    style: 'footerTable',
                    margin: footerMargins,
                    layout: 'noBordersNoPadding',

                    table: {
                        widths: ["40%", "20%", "40%"],
                        body: footerRows
                    }
                };
            }
        }();
    }

    makeSingleTotalRow(name, value, lineMargins, nameStyle, valueStyle) {
        return {
            columns: [
                {
                    width: 'auto',
                    style: nameStyle,
                    text: name
                },
                {
                    width: '*',
                    margin: lineMargins ? lineMargins : [2, 5, 2, 4],
                    table: {
                        widths: ['*'],
                        headerRows: 1,
                        body: [
                            [{text: ''}]
                        ]
                    },
                    layout: leaveTotalColumnLayout
                },
                {
                    width: 'auto',
                    style: valueStyle,
                    text: value
                }
            ]
        };
    }

    makeTotalTimeColumns(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn) {
        var showScheduled = !_.isNull(effectiveDuration);
        var reportedColSpan = (showScheduled) ? 1 : 3;
        var wrapHelper = function(valStr,  ext)
        {
            var text = _.extend({noWrap: true, text: valStr}, ext);
            return (valStr && valStr.length > 6) ? [' ', text] : text;
        };
        var totalTimeTableBody = [
            ['', {noWrap: true, text: messageResource.getMessage("view_tt.totals.reported"), style:'viewTTtotalsReported', colSpan: reportedColSpan},'',
             {noWrap: true, text: messageResource.getMessage("view_tt.totals.scheduled"), style:'viewTTtotalsScheduled'}],
            [{text: messageResource.getMessage("view_tt.totals.for", [dateStr])},
                wrapHelper(totalSpent, {style: 'viewTTtotalsReported', colSpan: reportedColSpan}),
                {text: messageResource.getMessage("view_tt.totals.of"), alignment: 'right'},
                {noWrap: true, text: ' ' + effectiveDuration + ' ', style:'viewTTtotalsScheduled'}]
        ];
        if (totalSpentForToday)
        {
            totalTimeTableBody.push(
                [{text: messageResource.getMessage("view_tt.totals.today")},
                    wrapHelper(totalSpentForToday, {style: 'viewTTtotalsReported', colSpan: reportedColSpan}),
                    {text: messageResource.getMessage("view_tt.totals.of"), alignment: 'right'},
                    wrapHelper(effectiveDurationForToday, {style:'viewTTtotalsScheduled'})]);
        }

        var futureDateRange = ViewTTStore.getDateRangeConfig().fromDate > ViewTTStore.getUserInfo()["today"];
        if (totalDiffVal !== 0 && !futureDateRange)
        {
            var totalDiffMsg = messageResource.getMessage(totalDiffVal > 0 ? 'view_tt.totals.diff.more' : 'view_tt.totals.diff.less');
            var totalDiffClass = totalDiffVal > 0 ? 'viewTTtotalsDiffMore' : 'viewTTtotalsDiffLess';
            var totalDiff = UserTime.formatTimeWithDigitSeparator(Math.abs(totalDiffVal));

            totalTimeTableBody.push(
                    [{text: [
                        { text: totalDiff + '  ', bold: true},
                        { text: totalDiffMsg }
                    ], style: totalDiffClass, colSpan: 4}]
            );
        }
        var totalTimeLabel = {text: messageResource.getMessage("view_tt.totals.period") + '\n', style: 'viewTTtotalsSpent',
            margin: (showSecondColumn) ? [] : [0, 16, 0, 0]};
        var totalTimeTable = {table: {
            headerRows: 1,
            widths: (showScheduled) ? ['50%', '18%', '8%', '18%'] : ['50%', '18%', '0%', '0%'],
            body: totalTimeTableBody
        }, style: 'viewTTtotalsTimeTable',
            layout: {
                vLineWidth: function(i, node) {
                    return 0;
                },
                hLineWidth: function(i, node) {
                    var rowsN = node.table.body.length;
                    return ( i === 0 || i === rowsN || i === rowsN - 1) ? 0: 1;
                },
                hLineColor: function(i, node) {
                    return  '#dbdedf';
                }
            }

        };

        var totalsColumn = (showSecondColumn) ? {width: '35%', stack: [totalTimeLabel,totalTimeTable]} :
                {width: '50%', columns: [_.create(totalTimeLabel, {width: '25%'}), _.create(totalTimeTable, {width: '75%'})]};

        return [totalsColumn];
    }

    appendTotalWorkingTime(totalWorkingTime, totalWorkingTimeStack) {
        var totalWorkingTimeDefinition = this.makeSingleTotalRow(messageResource.getMessage("view_tt.totals.total_working_time"), totalWorkingTime,
                                                                 null, 'viewTTTotalLabel', 'viewTTTotalValue');
        totalWorkingTimeStack.push(totalWorkingTimeDefinition);
        totalWorkingTimeDefinition.margin = [0, 0, 0, 12];
    }

    appendRegularWorkingTime(regularWorkingTime, totalWorkingTimeStack) {
        var regularWorkingTimeDefinition = this.makeSingleTotalRow(messageResource.getMessage("view_tt.totals.regular_working"),
                                                                   regularWorkingTime, null,
                                                                   'viewTTTotalLabel', ['viewTTTotalSubValue']);
        totalWorkingTimeStack.push(regularWorkingTimeDefinition);
    }

    appendTotalOvertime(totalOvertime, totalWorkingTimeStack) {
        var totalOvertimeDefinition = this.makeSingleTotalRow(messageResource.getMessage("view_tt.totals.overtime"),
                                                              totalOvertime,
                                                              null, ['viewTTTotalLabel'],
                                                              ['viewTTTotalSubValue']);
        totalOvertimeDefinition.style = 'leaveMargins';
        totalWorkingTimeStack.push(totalOvertimeDefinition);
    }

    appendTotalAutoOvertime(totalAutoOvertime, totalWorkingTimeStack) {
        var totalAutoOvertimeDefinition = this.makeSingleTotalRow(messageResource.getMessage("view_tt.totals.auto_overtime"),
                                                                  totalAutoOvertime,
                                                                  null, ['viewTTTotalLabel'],
                                                                  ['viewTTTotalSubValue']);
        totalAutoOvertimeDefinition.style = 'leaveMargins';
        totalWorkingTimeStack.push(totalAutoOvertimeDefinition);
    }

    appendTotalLeaveTime(totalLeaveTime, leaveTimeTotals, columns) {
        var additionalTotalsTable = [];
        var leaveTotalsDefinition = this.makeSingleTotalRow(messageResource.getMessage("view_tt.totals.leave_time"), totalLeaveTime,
                                                            null, 'viewTTTotalLabel', 'viewTTTotalValue');

        leaveTotalsDefinition.margin = [0, 0, 0, 10];
        additionalTotalsTable.push(leaveTotalsDefinition);

        var self = this;
        var leaveMaxLen = this.p("leaveTextLen");
        _.each(leaveTimeTotals, function(leave)
        {
            var leaveTotalsDefinition = self.makeSingleTotalRow(cutLongText(leave.name, leaveMaxLen), leave.value, null, 'viewTTLeaveTotal', 'viewTTLeaveTotal');
            leaveTotalsDefinition.style = 'leaveMargins';
            additionalTotalsTable.push(leaveTotalsDefinition);
        });

        columns.push({
                         margin: [20, 0, 0, 0],
                         stack: additionalTotalsTable
                     });
    }

    getTotalElementBuilder(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn) {
        var self = this;
        var tableStyles = this.p("dataTableCommonStyles").small;
        var columns = this.makeTotalTimeColumns(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn);
        var totalWorkingTimeStack = [];

        return {
            appendSecondColumn: function(showLeaves)
            {
                var totalWorkingTimeStackMargins = showLeaves ? [5, 0, 5, 0] : [135, 0, 5, 0];
                columns.push({
                                 margin: totalWorkingTimeStackMargins,
                                 stack: totalWorkingTimeStack
                             });
            },

            appendTotalWorkingTime: function(totalWorkingTime)
            {
                self.appendTotalWorkingTime(totalWorkingTime, totalWorkingTimeStack);
            },

            appendRegularWorkingTime: function(regularWorkingTime)
            {
                self.appendRegularWorkingTime(regularWorkingTime, totalWorkingTimeStack);
            },

            appendTotalOvertime: function(totalOvertime)
            {
                self.appendTotalOvertime(totalOvertime, totalWorkingTimeStack);
            },

            appendTotalAutoOvertime: function(totalAutoOvertime)
            {
                self.appendTotalAutoOvertime(totalAutoOvertime, totalWorkingTimeStack);
            },

            appendTotalLeaveTime: function(totalLeaveTime, leaveTimeTotals)
            {
                self.appendTotalLeaveTime(totalLeaveTime, leaveTimeTotals, columns);
            },

            build: function()
            {
                self.appendContentElement({
                                              style: tableStyles.tableStyle,
                                              layout: 'headerBorderSeparatedRows',
                                              marginTop: 20,
                                              columns: columns
                                          });
            }
        };
    }

    addChartImage(viewByText, image) {
        var sizes = this.p("chartImageSize");

        this.appendContentElement({
                                      marginTop: 30,
                                      marginBottom: 0,
                                      text: viewByText,
                                      style: 'viewChartBy',
                                      headlineLevel: 1
                                  });

        this.appendContentElement({
                                      layout: 'noBordersNoPadding',
                                      headlineLevel: 2,
                                      marginTop: 5,
                                      marginBottom: 0,
                                      table: {
                                          width: ['100%'],
                                          body: [
                                              [
                                                  {
                                                      height: sizes.height,
                                                      width: sizes.width,
                                                      image: image
                                                  }
                                              ]
                                          ]
                                      }
                                  }
        );
    }

    addDataTableWithHeader(headerText, dataRows) {
        var tableMargins = {
            top: 20
        };
        var tableStyles = this.p("dataTableStyles");

        var rows = [];
        rows.push([{width: '100%', noWrap: true, style: tableStyles.tableHeaderStyle, text: headerText, colSpan: 3}, {}, {}]);
        rows = rows.concat(dataRows);

        var table = {
            style: tableStyles.tableStyle,
            layout: 'headerBorderSeparatedRows',
            marginTop: tableMargins.top,

            table: {
                dontBreakRows: true,
                widths: ['47%', '6%', '47%'],
                body: rows
            }
        };
        this.appendContentElement(table);
    }

    crateDayRowDescription(data, params) {
        var columns = [];
        var columnsCount = 1;
        if (params.isOvertimePresent)
            columnsCount++;
        if (params.isLeaveTimePresent)
            columnsCount++;

        var columnPercentWidth = (Math.round((100 / columnsCount) * 10) / 10) + "%";
        columns.push(
                {width: columnPercentWidth, style: ["dayRowDescription", params.isEmptyWorkingTime ? "emptyTableData" : ""], text: data.workingTime}
        );
        if (params.isOvertimePresent)
        {
            columns.push(
                    {width: columnPercentWidth, style: ["dayRowDescription", params.isEmptyOvertime ? "emptyTableData" : ""], text: data.overtime}
            );
        }
        if (params.isLeaveTimePresent)
        {
            columns.push(
                    {width: columnPercentWidth, style: ["dayRowDescription", params.isEmptyLeaveTime ? "emptyTableData" : ""], text: data.leaveTime}
            );
        }
        return columns;
    }

    createDayRow(data, params, description) {
        var lockedImage = params.locked ? {width: 9, image: data.lockImage} : {width: 0, text: ""};
        return [
            {
                style: [params.isWeekend ? "weekendRow" : ""], marginLeft: params.locked ? 0 : 15, alignment: 'left',
                columns: [
                    lockedImage,
                    {
                        marginLeft: params.locked ? 5 : 0,
                        width: "55%",
                        text: [
                            {style: ["tableText", "tableFirstLevel"], text: data.category},
                            {style: ["tableSubText"], text: " " + data.nonWorkingLabel}
                        ]
                    },
                    {
                        width: "*",
                        text: data.statusLabel, style: ["dayRowStatus", params.statusClass]
                    }
                ]
            },
            {
                style: ["total", "firstLevelTotal", params.isWeekend ? "firstLevelTotalWeekend" : "", params.isEmptyTotal ? "emptyTableData" : ""],
                text: data.total
            },
            {
                style: [params.isWeekend ? "weekendRow" : ""],
                margin: [0, 0, 0, 0],
                columns: description
            }
        ]
    }

    createTaskByDayRow(data, params) {
        var ellipseCanvas = {
            canvas: [{
                type: 'ellipse',
                x: -7.8,
                y: 4.5,
                r1: 4.3,
                color: data.color
            }],
            width: 'auto',
            marginLeft: 24
        };
        var imageColumn = {
            width: 9,
            image: data.image,
            absolutePosition: {x: 34.8, y: 5}
        };
        return [
            {
                style: ["daySubRow", params.isWeekend ? "weekendRow" : ""],
                marginLeft: 18,
                columns: [
                    ellipseCanvas,
                    imageColumn,
                    {
                        marginLeft: -10,
                        stack: [
                            {
                                width: "*",
                                style: ["tableText", params.isCompleted ? "completedTask" : ""],
                                text: data.category
                            },
                            {
                                style: ["tableSubText", "tableGrayText"],
                                marginTop: 1,
                                text: data.customerName + " / " + data.projectName
                            }
                        ]
                    }
                ]
            },
            {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            },
            {
                text: cutNumberOfTextLines(data.comment, this.p("limitOfLinesInTextCell")),
                style: ["tableText", "taskComment", params.isWeekend ? "weekendRow" : ""]
            }
        ];
    }

    createTaskByCpRow(data, params) {
        var ellipseCanvas = {
            canvas: [{
                type: 'ellipse',
                x: -7.8,
                y: 4.5,
                r1: 4.3,
                color: data.color
            }],
            width: 'auto',
            marginLeft: 19
        };
        var imageColumn = {
            width: 9,
            image: data.image,
            absolutePosition: {x: 34.8, y: 5}
        };
        return [
            {
                marginLeft: 23,
                columns: [
                    ellipseCanvas,
                    imageColumn,
                    {
                        marginLeft: -10,
                        width: "*",
                        style: ["tableText", params.isCompleted ? "completedTask" : ""],
                        text: data.category
                    }
                ]
            },
            {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            },
            {
                style: ["tableText", "taskComment"],
                text: cutNumberOfTextLines(data.description, this.p("limitOfLinesInTextCell"))
            }
        ]
    }

    createProjectRow(data) {
        return [
            {
                marginLeft: 20,
                style: "tableText",
                text: data.category
            },
            {
                style: ["total"], text: data.total
            },
            ''
        ]
    }

    createCustomerRow(data) {
        return [
            {
                marginLeft: 10,
                style: ["tableText", "tableFirstLevel"],
                text: data.category
            },
            {
                style: ["total", "firstLevelTotal"], text: data.total
            },
            ''
        ]
    }

    createLeaveRow(data, params) {
        return [
            {
                style: ["daySubRow", params.isWeekend ? "weekendRow" : ""],
                columns: [
                    {
                        marginTop: 1,
                        width: 8,
                        height: 8,
                        image: data.image
                    },
                    {
                        marginLeft: 3,
                        width: "*",
                        text: data.category
                    }
                ]
            },
            {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            },
            {
                style: ["tableText", params.isWeekend ? "weekendRow" : ""],
                text: ""
            }
        ];
    }

    createOvertimeRow(data, params) {
        return [
            {
                style: ["daySubRow", params.isWeekend ? "weekendRow" : ""],
                stack: [
                    {
                        style: ["tableText"],
                        text: data.category
                    },
                    {
                        marginTop: params.showAuto ? 3 : 0,
                        style: ["tableSubText", "tableGrayText"],
                        text: data.autoOvertimeMsg
                    }
                ]
            },
            {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            },
            {
                style: ["tableText", params.isWeekend ? "weekendRow" : ""],
                text: ""
            }
        ];
    }

    createOtherSpentByDayRow(data, params) {
        return [
            {
                style: ["tableText", "daySubRow", "tableGrayText", params.isWeekend ? "weekendRow" : ""],
                text: data.category
            },
            {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            },
            {
                style: ["tableText", params.isWeekend ? "weekendRow" : ""],
                text: ""
            }
        ];
    }

    createOtherSpentByCpRow(data) {
        return [
            {
                style: ["tableText", "tableGrayText"],
                marginLeft: 10,
                text: data.category
            },
            {
                style: ["total"],
                text: data.total
            },
            ''
        ];
    }

    createEmptyDataRow(message) {
        return [
            {
                style: ["tableText", "tableGrayText", "emptyTableRow"],
                text: message,
                colSpan: 3
            },
            '',
            ''
        ];
    }

}

export const PDFDefinitionBuilderParameters = {

    dataTableStyles: {
        tableHeaderStyle: "viewTTHeader",
        tableStyle: 'viewTTRows',
        tableValueStyles: {
            nameValueStyle: 'viewTTRows',
            timeValueStyle: 'coloredTime',
            commentValueStyle: 'viewTTRows'
        }
    },

    dataTableCommonStyles: {
        small: {
            tableStyle: 'dataTableSmall',
            tableValueStyles: {
                dataValueStyle: 'dataValueSmall',
                dataValueWithPercentStyle: 'dataValueWithPercentsSmall',
                dataNameStyle: 'dataNameSmall',
                colorRectangleDimensions: {
                    width: 8,
                    x: 4,
                    y: 1.25,
                    h: 3.8,
                    w: 7
                }
            }
        },
        big: {
            tableStyle: 'dataTable',
            tableValueStyles: {
                dataValueStyle: 'dataValue',
                dataValueWithPercentStyle: 'dataValueWithPercents',
                dataNameStyle: 'dataName',
                colorRectangleDimensions: {
                    width: 10,
                    x: 4,
                    y: 4,
                    h: 5,
                    w: 9
                }
            }
        }
    },

    Portrait: {
        A4: {
            limitOfLinesInTextCell: 62,
            chartImageSize: {
                height: 238,
                width: 515
            }
        },
        Letter: {
            limitOfLinesInTextCell: 56,
            chartImageSize: {
                height: 245,
                width: 530
            }
        }
    },
    Landscape: {
        A4: {
            limitOfLinesInTextCell: 40,
            chartImageSize: {
                height: 290,
                width: 730
            }
        },
        Letter: {
            limitOfLinesInTextCell: 42,
            chartImageSize: {
                height: 310,
                width: 680
            }
        }
    }
}

const PDFDefinitionBuilderStyles = {
    viewTTHeader: {
        fillColor: '#EFEFEF',
        color: '#373737',
        fontSize: 9,
        alignment: 'left',
        margin: [12, 3, 0, 3],
        border: 1
    },
    viewTTRows: {
        fontSize: 9,
        alignment: 'left'
    },

    emptyTableData: {
        color: '#85898e'
    },

    emptyTableRow: {
        marginTop: 5,
        marginBottom: 5,
        alignment: "center"
    },

    tableFirstLevel: {
        bold: true
    },

    tableText: {
        fontSize: 8
    },

    tableSubText: {
        fontSize: 7
    },

    tableGrayText: {
        color: '#8a8a8a'
    },

    daySubRow: {
        marginLeft: 30
    },

    taskByDaysCompleted: {
        marginLeft: 18
    },

    dayRowDescription: {
        marginLeft: 5,
        alignment: 'left',
        fontSize: 7
    },

    dayRowStatus: {
        alignment: "right",
        fontSize: 7,
        marginRight: 3,
        marginTop: 0
    },

    dayRowTotal: {
        fillColor: '#ebf2f9'
    },

    firstLevelTotalWeekend: {
        fillColor: '#e7e8ec'
    },

    leaveMargins: {
        margin: [0, 2, 0, 0]
    },

    total: {
        fillColor: '#f5f9fc',
        alignment: "center",
        fontSize: 8
    },

    totalWeekend: {
        fillColor: '#EEEFF2'
    },

    firstLevelTotal: {
        fillColor: '#ebf2f9',
        bold: true
    },

    weekendRow: {
        fillColor: '#f4f5f7'
    },

    approved: {
        color: '#61a861'
    },
    notReady: {
        color: '#999ea3'
    },
    ready: {
        color: '#5c5e62'
    },
    rejected: {
        color: '#e85a34'
    },

    completedTask: {
        color: '#716e6e'
    },

    taskComment: {
        color: '#999ea3'
    },

    coloredTime: {
        fillColor: '#f5f9fc',
        fontSize: 9,
        alignment: 'center'
    },

    coloredBoldTime: {
        bold: true,
        fillColor: '#ebf2f9'
    },

    viewTTtotalsReported: {
        alignment: 'right'
    },

    viewTTtotalsScheduled: {
        alignment: 'right'
    },

    viewTTtotalsDiffLess: {
        color: '#e45600',
        alignment: 'right'
    },

    viewTTtotalsDiffMore: {
        color: '#4C8A54',
        alignment: 'right'
    },

    viewTTtotalsTimeTable: {
        fontSize: 9
    },

    viewTTtotalsSpent: {
        fontSize: 10,
        bold: true
    },

    viewTTtotalsSpentValue: {
        fontSize: 17
    },

    viewTTtotalsOf: {
        fontSize: 10
    },

    viewTTLine: {
        marginTop: 6
    },

    viewTTTotalLabel: {
        fontSize: 10
    },

    viewTTTotalValue: {
        fontSize: 10,
        bold: true
    },

    viewTTTotalSubValue: {
        fontSize: 10
    },

    viewTTLeaveTotal: {
        fontSize: 10
    },

    viewChartBy: {
        fontSize: 10
    },

    footerTable: {
        fontSize: 9
    },

    footerSignature: {
        alignment: 'left',
        color: '#3D3D3D',
        marginBottom: 5
    },
    footerSignatureSeparator: {
        marginBottom: 5
    },
    footerPageCount: {
        alignment: 'right',
        color: '#6A6A6A',
        fontSize: 7
    }
}

const leaveTotalColumnLayout = {
    hLineWidth: function(i)
    {
        return (i === 1) ? 0.5 : 0;
    },
    vLineWidth: function()
    {
        return 0;
    },
    hLineColor: function()
    {
        return '#afb4b9';
    },
    vLineColor: function()
    {
        return 0;
    }
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdf/PDFDefinitionBuilder.js